<template>
  <div>
    <div v-if="!$route.query.transaction_token">Error</div>
    <div v-else>
      Done
      <a href="javascript:void(0)" router to="/home">Back home</a>
    </div>
    <div v-show="isLoading">
      <div class="popup--visible">
        <div style="padding: 15%">
          <div class="text-center mt-5">
            <div class="mb-5">
              <div
                style="
                  font-size: 18px;
                  font-weight: 600;
                  color: red;
                  font-family: Open Sans;
                "
              >
                <span>NO CIERRE LA VENTANA</span>
                <p>SU PAGO SE ESTÁ PROCESANDO...</p>
              </div>
              <p></p>
              <p
                style="
                  font-size: 18px;
                  font-weight: 600;
                  font-family: Open Sans;
                "
              >
                Será direccionado de nuevo al sistema de solicitudes en unos
                segundos.
              </p>
            </div>
            <mdb-spinner big color="yellow" />
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { mdbSpinner } from "mdbvue";
import Swal from "sweetalert2";
export default {
  name: "ThreeDSecure",
  components: {
    mdbSpinner,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  async mounted() {
    try {
      //console.log("Se enciende animacion");
      this.isLoading = true;
      //console.log("se hace peticion");
      let response = await this.check3DSecure(
        this.$route.query.transaction_token
      );
      //console.log("Peticion completada");
      //console.log(response.data);
      if (response.data.status == 200) {
        //console.log("Respuesta 200");
        //console.log("Notify success");

        //console.log(response.data.message);
        this.$notify.success({
          message: response.data.message,
          position: "top right",
          timeOut: 5000,
        });

        //console.log("Prepare redirect");
        //console.log(response.data.data);
        let dataRedir = {};
        dataRedir.name = response.data.data.applicantName;
        dataRedir.shareType = response.data.data.membershipType;
        dataRedir.status = response.data.data.paymentStatus;
        dataRedir.total = response.data.data.total;

        await this.setPaymentDoneData(JSON.stringify(dataRedir));
        localStorage.setItem("payment_approved", true);
        this.isLoading = false;
        this.$router.push("/home/paymentdone");
      }
    } catch (e) {
      //console.log("CATCH DE VERIFICACION DE TOKEN");
      //console.log(e);

      let validText =
        "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
        "<p><span style='font-weight: 600; color: #dc7134 !important; '>" +
        e.response.data.message +
        "</span><br/> Por favor vuelve a intentar con otra tarjeta o comunícate con tu banco para más detalles.</p>" +
        "</div>";

      this.isLoading = false;
      Swal.fire({
        icon: "error",
        title: "No se pudo completar el pago.",
        //text: "Por favor vuleve a intentar o comunícate con tu banco para más detalles.",
        html: validText,
        allowOutsideClick: false,
      }).then((result) => {
        this.$router.push("/home/payment");
      });

      this.$notify.danger({
        message: "Hay un error al intentar procesar la solicitud",
        position: "top right",
        timeOut: 5000,
      });
    }
  },
  methods: {
    ...mapActions(["check3DSecure", "setPaymentDoneData"]),
  },
};
</script>